module.exports = __webpack_public_path__ + "static/media/product-5.4df14846.png";